import type { BookingSlot } from '../../types/bookings'

type BookingDaySlotsProps = {
  slots: BookingSlot[]
  onPick: (slot: BookingSlot) => void
  selectedStartAt?: string | null
  timeZone?: string
}

function slotGroupLabel(slot: BookingSlot, timeZone?: string): 'Morning' | 'Afternoon' | 'Evening' {
  const date = new Date(slot.starts_at)
  let hour = date.getHours()
  if (timeZone) {
    try {
      const formatted = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        hour12: false,
        timeZone,
      }).format(date)
      hour = Number(formatted)
    } catch {}
  }
  if (hour < 12) return 'Morning'
  if (hour < 17) return 'Afternoon'
  return 'Evening'
}

export default function BookingDaySlots({ slots, onPick, selectedStartAt = null, timeZone = undefined }: BookingDaySlotsProps) {
  const groups: Record<'Morning' | 'Afternoon' | 'Evening', BookingSlot[]> = {
    Morning: [],
    Afternoon: [],
    Evening: [],
  }
  for (const slot of slots) groups[slotGroupLabel(slot, timeZone)].push(slot)

  return (
    <div className="space-y-3">
      {(['Morning', 'Afternoon', 'Evening'] as const).map((label) => (
        <div key={label}>
          <div className="mb-1 text-xs font-semibold text-white/70">{label} ({groups[label].length})</div>
          {groups[label].length === 0 ? (
            <div className="text-xs text-white/45">No slots</div>
          ) : (
            <div className="flex flex-wrap gap-2">
              {groups[label].map((slot) => {
                const selected = selectedStartAt === slot.starts_at
                return (
                <button
                  key={slot.starts_at}
                  type="button"
                  disabled={typeof slot.remaining_capacity === 'number' && slot.remaining_capacity <= 0}
                  onClick={() => onPick(slot)}
                  className={`rounded-full border px-3 py-1.5 text-sm text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/70 disabled:cursor-not-allowed disabled:opacity-40 ${
                    selected
                      ? 'border-brand/70 bg-brand/25'
                      : 'border-white/15 bg-white/5 hover:bg-white/10'
                  }`}
                >
                  {new Date(slot.starts_at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', timeZone: timeZone || undefined })}
                </button>
                )
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
